import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter } from "./Filter";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { IncentiveReqList } from "./IncentiveReqList";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { format, set } from "date-fns";
import { IncentiveConsultantDetail } from "./IncentiveConsultantDetail";
import { ILogin } from "../../models/Login";

interface IProps {
    toast: any,
}

export interface IIncentiveList {
    user_Name?: string,
    company_Name?: string,
    branchName?: string,
    totalPer?: number,
    pOs?: number,
    pO_ID?: number,
    mRate?: number,
    totalRupeeAmount?: number,
    user_ID?: number,
    user_EmailID?: string,
    user_Employee_ID?: string,
    threeMPO?: number,
    fourMPO?: number,
    totalECI?: number,
    grossSalary?: number,
    experience?: boolean,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IIncentiveList[], loading: boolean });
    const [incentiveFilter, setIncentiveFilter] = useState(EmptyFilter);
    const [modal, setModal] = useState({ singleData: {}, open: false } as { singleData: IIncentiveList, open: boolean });
    const [openIncentiveConsultantDetailModal, setOpenIncentiveConsultantDetailModal] = useState({ singleData: {}, open: false } as { singleData: IIncentiveList, open: boolean });
    const [isReleased, setIsReleased] = useState<boolean>(false);
    const [releaseLoading, setReleaseLoading] = useState<boolean>(false);
    const hideIncentiveConsultantDetailModal = () => {
        setOpenIncentiveConsultantDetailModal({ singleData: {}, open: false })
    }
    const [selectedUserInvoice, setSelectedUserInvoice] = useState<IIncentiveList[]>([]);
    const [showSelectedUserInvoice, setShowSelectedUserInvoice] = useState<boolean>(false);
    const dt = useRef<any>();
    const dt2 = useRef<any>();
    const header = () => {
        return (
            <React.Fragment>
            </React.Fragment>
        );
    };

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const isReleasedQuery = isReleased === true ? '&isReleased=1' : '';
        let filter: any = incentiveFilter;
        if (isReleased === true) {
            delete filter.viewType;
        };

        const response = await Fetch("InvoiceTracking/allIncentiveList", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}` + isReleasedQuery, null);
        if (response) {
            const data: IIncentiveList[] = await response.json();
            setSelectedUserInvoice([]);
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };
    const hideDialog = () => {
        setModal({ singleData: {}, open: false });
    };
    const onReleasePayment = async () => {
        if (_roles.includes(1)) {
            if (incentiveFilter.month === null) {
                props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please Select a month from filter', life: 3000 });
            } else if (selectedUserInvoice.length > 0) {
                setReleaseLoading(true);
                const selectedIDs: any = selectedUserInvoice.map((user) => {
                    return { user_Employee_ID: user.user_Employee_ID, amount: user.totalRupeeAmount, user_EmailID: user.user_EmailID, month: ((incentiveFilter.month?.getMonth() || 0) + 1), year: incentiveFilter.month?.getFullYear() };
                });
                const response = await Fetch("InvoiceTracking/releaseIncentiveAmount", "PUT", { incentives: selectedIDs }, null, props.toast);
                if (response) {
                    setReleaseLoading(false);
                    props.toast.current.show({ severity: 'success', summary: 'Success', detail: 'Payment released successfully', life: 3000 });
                    dt2.current.exportCSV();
                    setSelectedUserInvoice([]);
                    loadTableData();
                    onHideShowSelectedUserInvoice();
                } else {
                    setReleaseLoading(false);
                    props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to release payment', life: 3000 });
                }
            } else props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Select atleast one user for payment release', life: 3000 });
        } else props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Not Authorized To Release Incentive', life: 3000 });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Released" className={isReleased === true ? "p-button-success mr-2" : "p-button-outlined mr-2"} onClick={() => setIsReleased(true)} />
                <Button label="To Be Released" className={isReleased === false ? "p-button-success mr-2" : "p-button-outlined mr-2"} onClick={() => setIsReleased(false)} />
            </React.Fragment>
        );
    };
    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {selectedUserInvoice.length > 0 && isReleased == false && <div className="my-2">
                    <Button label="Release Payment" icon="pi pi-plus" className="p-button-primary mr-2" onClick={() => {
                        setSelectedUserInvoice(selectedUserInvoice.map(el => {
                            const date = new Date(new Date().getFullYear(), new Date().getMonth()); // month is 0-based
                            const options: any = { year: 'numeric', month: 'long' };
                            const formatted = date.toLocaleString('en-US', options);

                            return {
                                user_Name: el.user_Name,
                                user_EmailID: el.user_EmailID,
                                user_Employee_ID: el.user_Employee_ID,
                                company_Name: el.company_Name,
                                branchName: el.branchName,
                                totalRupeeAmount: el.totalRupeeAmount,
                                incentiveDate: format(new Date(), 'yyyy-MM-dd').toUpperCase()
                            }
                        }));
                        if (_roles.includes(1)) {
                            setShowSelectedUserInvoice(true);
                        }
                    }} />
                </div>}
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                {loginObj.id === 1 && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
            </React.Fragment>
        );
    };

    const onHideShowSelectedUserInvoice = () => {
        setShowSelectedUserInvoice(false);
        setSelectedUserInvoice([]);
    }

    const totalIncentive = (rowData: IIncentiveList) => {
        return (
            <>
                <div className="flex justify-content-between gap-3">
                    <p className="cursor-pointer text-cyan-700 underline" onClick={() => setModal({ singleData: rowData, open: true })}>₹ {rowData.totalRupeeAmount}</p>
                    {/* <Button icon="pi pi-dollar" className="h-1rem p-button-text" onClick={() => { openIncentiveConsultantDetail(rowData) }} ></Button> */}
                </div>
            </>
        )
    }

    const openIncentiveConsultantDetail = (rowData: IIncentiveList) => {
        setOpenIncentiveConsultantDetailModal({ singleData: rowData, open: true })
    }

    useEffect(() => {
        loadTableData();
    }, [incentiveFilter, isReleased]);

    const now = new Date();

    // Go to previous month
    const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    const monthNum = prev.getMonth() + 1; // 1–12
    let month = "";
    if (monthNum === 1) month = "Jan";
    if (monthNum === 2) month = "Feb";
    if (monthNum === 3) month = "Mar";
    if (monthNum === 4) month = "Apr";
    if (monthNum === 5) month = "May";
    if (monthNum === 6) month = "Jun";
    if (monthNum === 7) month = "Jul";
    if (monthNum === 8) month = "Aug";
    if (monthNum === 9) month = "Sep";
    if (monthNum === 10) month = "Oct";
    if (monthNum === 11) month = "Nov";
    if (monthNum === 12) month = "Dec";
    const year = prev.getFullYear();

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate} ></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter incentiveFilter={incentiveFilter} setIncentiveFilter={(incentiveFilter: any) => setIncentiveFilter(incentiveFilter)} toast={props.toast} isReleased={isReleased} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines
                value={tableData.tableData} lazy dataKey="user_ID"
                // paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                // totalRecords={totalRecords} onPage={onPage}
                // onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedUserInvoice}
                onSelectionChange={(e) => {
                    const value = e.value as IIncentiveList[];
                    setSelectedUserInvoice(value);
                }}
            >
                {_roles.includes(1) && isReleased == false && <Column selectionMode="multiple" />}
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="user_Employee_ID" header="Employee ID" style={{ maxWidth: "5rem" }} />
                <Column field="user_Name" header="Name" />
                <Column field="role_Name" header="Role Name" />
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch Name" />
                <Column field="" header="Month Year" body={(rowData: any) => {
                    // const [year, month] = rowData.incentiveYearMonth.split("-").map(Number);
                    // const adjustedMonth = month - 2; // subtract 2 to shift months back
                    // // Handle wrap-around if adjustedMonth is < 0
                    // const normalizedMonth = adjustedMonth < 0 ? 11 : adjustedMonth;

                    // const date = new Date(year, normalizedMonth); // month is 0-based
                    // const options: any = { year: 'numeric', month: 'long' };
                    // const formatted = date.toLocaleString('en-US', options);
                    const prev = new Date(incentiveFilter.month || "");
                    prev.setMonth(prev.getMonth() - 1);

                    const year = prev.getFullYear();
                    const month = prev.toLocaleString("en-US", { month: "short" });
                    const formatted = `${year} ${month}`;

                    return <p>{formatted}</p>;
                }} />
                <Column field="totalRupeeAmount" header="Total Incentive" body={totalIncentive} />
                <Column field="present_Days" header={`Present Days In ${(month)}-${year}`} body={(rowData: any) => <p>{rowData.present_Days}</p>} />
                <Column field="actual_Incentive" header="Actual Incentive" body={(rowData: any) => <p>₹ {Number(rowData.actual_Incentive || "0").toFixed(2)}</p>} />
                <Column field="threeMPO" header="Three M PO" />
                <Column field="fourMPO" header="Four M PO" />
                <Column field="totalECI" header="ECI" />
                {/* <Column field="grossSalary" header="Salary" body={(rowData: any) => <p>₹ {rowData.grossSalary}</p>} /> */}
                <Column field="experience" header="Experienced" body={(rowData: any) => <p style={{ color: (rowData.experience === null || rowData.experience === false) ? "red" : "green" }}>{(rowData.experience === null || rowData.experience === false) ? "No" : "Yes"}</p>} />
            </DataTable>
            <IncentiveReqList open={modal.open} singleData={modal.singleData} hideDialog={hideDialog} toast={props.toast} FromDate={incentiveFilter.month} ToDate={null} isReleasedTrue={isReleased} isHold={(incentiveFilter.viewType === "Hold Incentive" && (isReleased === false || isReleased === null))} />
            <Dialog visible={showSelectedUserInvoice} style={{ width: '80vw' }} header={<p style={{ color: "#2196F3", fontWeight: "bolder" }}>Release Incentive</p>} className="p-fluid" onHide={onHideShowSelectedUserInvoice} draggable={true}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt2} size="small" stripedRows showGridlines
                    value={selectedUserInvoice} lazy dataKey="user_ID"
                    emptyMessage="No Users found."
                // header={header}
                // loading={tableData.loading}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="user_Name" header="Name" />
                    <Column field="company_Name" header="Company Name" />
                    <Column field="branchName" header="Branch Name" />
                    <Column field="totalRupeeAmount" header="Total Incentive" body={(rowData) => <p>₹ {rowData.totalRupeeAmount}</p>} />
                    {/* <Column field="present_Days" header="Present Days" body={(rowData: any) => <p>{rowData.present_Days}</p>} /> */}
                    {/* <Column field="actual_Incentive" header="Actual Incentive" body={(rowData: any) => <p>₹ {rowData.actual_Incentive}</p>} /> */}
                </DataTable>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", display: "none" }}
                    ref={dt2} size="small" stripedRows showGridlines
                    value={selectedUserInvoice} lazy dataKey="user_ID"
                    emptyMessage="No Users found."
                // header={header}
                // loading={tableData.loading}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="user_Name" header="Name" />
                    <Column field="user_EmailID" header="Email ID" />
                    <Column field="user_Employee_ID" header="Employee ID" />
                    <Column field="company_Name" header="Company Name" />
                    <Column field="branchName" header="Branch Name" />
                    <Column field="totalRupeeAmount" sortable header="Total Incentive 11" body={(rowData) => <p>₹ {rowData.totalRupeeAmount}</p>} />
                    <Column field="incentiveDate" header="Date" body={(rowData: any) => {
                        const date = new Date(new Date().getFullYear(), new Date().getMonth()); // month is 0-based
                        const options: any = { year: 'numeric', month: 'long' };
                        const formatted = date.toLocaleString('en-US', options);

                        return <p>{formatted}</p>;
                    }} />
                    <Column field="present_Days" header="Present Days" body={(rowData: any) => <p>{rowData.present_Days}</p>} />
                    <Column field="actual_Incentive" header="Actual Incentive" body={(rowData: any) => <p>₹ {rowData.actual_Incentive}</p>} />
                </DataTable>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button label="YES" type={"button"} style={{ width: '100px' }} loading={releaseLoading} disabled={releaseLoading} onClick={onReleasePayment} ></Button>
                    <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="NO" onClick={onHideShowSelectedUserInvoice} type="button" ></Button>
                </div>
            </Dialog>
            <IncentiveConsultantDetail singleData={openIncentiveConsultantDetailModal.singleData} open={openIncentiveConsultantDetailModal.open} hideDialog={hideIncentiveConsultantDetailModal} />
        </>
    );
}